






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { HistoryList, Balance } from '@/api'
import formatter from '@/helpers'

@Component
export default class FinanceHistoryList extends Vue {
  @Prop() list!: HistoryList
  @Prop(String) name!: string
  @Prop(String) payType!: string
  @Prop() balanceVals!: Balance

  formatDate (val: string | undefined): string {
    return formatter.formatDayNear(val)
  }

  filterType (): HistoryList {
    const filtered: HistoryList = []

    this.list.forEach(val => {
      if (val.pay_type === this.payType) {
        filtered.push(val)
      }
    })

    return filtered
  }
}
